<template>
    <b-container fluid class="p-3" v-cloak>
        <h1><t translations.title /></h1>

        <b-row>
            <b-col cols="4">
                <b-form-group :label="$t('translations.file')" label-for="input-language">
                    <b-form-file
                        id='input-file'
                        v-model="file"
                        accept=".json"
                        @input="uploadFile"
                        :placeholder="$t('translations.import.placeholder')"
                        :browse-text="$t('translations.import.button')">
                    </b-form-file>
                </b-form-group>
            </b-col>
            <b-col>
                <b-form-group label=" ">
                    <b-button @click="exportTranslations"><t translations.export /></b-button>
                </b-form-group>
            </b-col>
            <b-col>

                <b-form-group :label="$t('translations.babelmode')" label-for="input-babelmode">
                    <b-form-checkbox
                        id="input-babelmode"
                        value="babelMode"
                        @change='switchBabelMode'
                        switch />
                </b-form-group>
            </b-col>

            <b-col>
                <b-form-group :label="$t('translations.currentlanguage')" label-for="input-language">
                    <b-form-select
                        id="input-type"
                        value="language"
                        :options="languages"
                        @change="changeLanguage"
                        />
                </b-form-group>
            </b-col>
        </b-row>

        <b-row v-if='babelMode' class="p-2" small>
            <h2><t translations.list /></h2>
            <b-container fluid>
                <b-row class="p-2">
                    <b-col>
                        <b-form-input
                        id="filter-input"
                        v-model="filter"
                        type="search"
                        :placeholder="$t('translations.filter.placeholder')"
                        ></b-form-input>
                    </b-col>
                    <b-col>
                        <b-button
                            class="ml-3"
                            v-b-modal.create-modal
                            @click="createTranslation()">
                            <t translations.create />
                        </b-button>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-table hover :items="textItems" :fields="fields" :filter="filter" class="translations-table">
                            <template v-slot:cell(key)="row">
                                <b-button @click="deleteKey(row.item)" size="sm" class="mr-3"><b-icon icon="trash" variant="outline-danger"></b-icon></b-button>{{row.item.key}}
                            </template>
                            <template v-slot:cell(fr)="row">
                                <b-form-input v-model="row.item.fr" @blur="onBlur(row.item, 'fr')"/>
                            </template>
                            <template v-slot:cell(de)="row">
                                <b-form-input v-model="row.item.de" @blur="onBlur(row.item, 'de')"/>
                            </template>
                            <template v-slot:cell(en)="row">
                                <b-form-input v-model="row.item.en" @blur="onBlur(row.item, 'en')"/>
                            </template>
                        </b-table>
                    </b-col>
                </b-row>
            </b-container>


        </b-row>

        <b-modal
            id="create-modal"
            ref="create-modal"
            hide-header
            hide-footer
            v-if="form"
            >
            <b-form  @submit="onSubmitCreate" @reset="onReset">
                <b-form-group
                    id="key-fieldset"
                    :label="$t('translations.key')"
                    label-for="key-input"
                    >

                    <b-form-input
                        id="key-input"
                        v-model="form.key"
                        required
                        >
                    </b-form-input>
                </b-form-group>

                <b-form-group
                    id="fr-fieldset"
                    :label="$t('language.fr')"
                    label-for="fr-input"
                    >

                    <b-form-input
                        id="fr-input"
                        v-model="form.fr"
                        required
                        >
                    </b-form-input>
                </b-form-group>

                <b-button type="submit" variant="primary" class="mr-2"><t common.save /></b-button>
                <b-button type="reset" variant="danger"><t common.cancel /></b-button>
            </b-form>
        </b-modal>
    </b-container>
</template>

<script>
    /* eslint-disable vue/no-unused-components */
import { BContainer, BButton, BFormCheckbox, BFormGroup, BFormSelect, BFormFile, BRow, BCol, BButtonGroup, BTable, BFormInput, BModal, BForm, VBModal, BIcon, BIconTrash } from 'bootstrap-vue'
import { models } from 'feathers-vuex';
import FileSaver from 'file-saver';
import { mapGetters } from 'vuex';

export default {
    components: {
        BContainer,
        BButton,
        BFormCheckbox,
        BFormGroup,
        BFormSelect,
        BFormFile,
        BRow,
        BCol,
        BButtonGroup,
        BTable,
        BFormInput,
        BModal,
        BForm,
        BIcon,
        BIconTrash
    },
    directives: {'b-modal': VBModal },
    data() {
        return {
            translationsList: [],
            allTranslations: {},
            file: null,
            languages: ['fr', 'de', 'en'],
            fields: [
                { key: 'key', sortable: true },
                { key: 'fr', sortable: true },
                { key: 'de', sortable: true },
                { key: 'en', sortable: true }
            ],
            textItems: [],
            filter: null,
            form: null
        }
    },
    computed: {
        ...mapGetters([
            'babelMode',
            'language',
            'translations',
            'frenchTexts',
            'foreignLanguage'
        ])
    },
    async mounted() {
        await this.refreshTranslations();
    },

    methods: {
        async refreshTranslations() {
            let blockSize = 40;
            let response = await models.api.Translation.find({ query: { $limit: blockSize } });
            this.translationsList = response.data;
            let steps = response.total / blockSize;

            for (let i = 1; i < steps; i++) {
                response = await models.api.Translation.find({ query: { $limit: blockSize, $skip: i * blockSize } });
                this.translationsList = this.translationsList.concat(response.data);
            }

            this.allTranslations = this.translationsList.reduce((acc, val) => {
                if (!acc[val.key]) acc[val.key] = {};
                acc[val.key][val.language] = val.text;
                return acc;
            }, {});

            this.textItems = Object.entries(this.allTranslations).reduce((acc, [key, value]) => {
                acc.push({
                    key: key,
                    ...value
                });
                return acc;
            }, []);
        },

        async exportTranslations() {
            var blob = new Blob([JSON.stringify(this.allTranslations, null, '  ')], {type: "application/json;charset=utf-8"});
            FileSaver.saveAs(blob, "obelix.translations." + Date.now() + ".json");
        },

        async importTranslations(newTranslations) {
            let modified = 0,
                created = 0;
            for (const [key, texts] of Object.entries(newTranslations)) {
                for (const [language, text] of Object.entries(texts)) {
                    let response = await this.saveTranslation(key, language, text);

                    if (response == 'modified') modified++;
                    if (response == 'created') created++;
                }
            }

            this.$bvToast.toast(`Créés : ${created}, modifiés : ${modified}`, {
                variant: 'info',
                title: "Traductions importées",
                autoHideDelay: 2000,
                solid: true
            });
        },

        async uploadFile() {
            if(!this.file) {
                console.error('Pas de fichier envoyé');
                return;
            }

            try {
                let contentBuffer = await readFileAsync(this.file);
                await this.importTranslations(JSON.parse(contentBuffer));
            } catch (e) {
                this.$bvToast.toast(e.message, {
                    variant: 'error',
                    title: "Oh tristesse",
                    autoHideDelay: 5000,
                    solid: true
                });
            }

            await this.refreshTranslations();
            await this.$store.dispatch('reloadTranslations');
        },

        async switchBabelMode() {
            await this.$store.dispatch('setBabelMode', !this.babelMode);
        },

        async changeLanguage(lang) {
            await this.$store.dispatch('setLanguage', lang);
        },

        createTranslation() {
            this.form = {
                key: '',
                fr: ''
            };
        },

        async onBlur(translation, language) {
            await this.saveTranslation(translation.key, language, translation[language]);
        },

        async saveTranslation(key, language, text) {
            let translation = this.translationsList.find(t => t.key == key && t.language == language);

            try {
                if (translation && translation.text != text) {
                    translation.text = text;
                    await translation.save();
                    return 'modified';
                }
                if (!translation) {
                    let t = new models.api.Translation({language, key, text});
                    await t.create();
                    return 'created';
                }
            } catch (e) {
                console.error(e)
                return 'error';
            }
        },

        async onSubmitCreate() {
            await this.saveTranslation(this.form.key, 'fr', this.form.fr);
            await this.refreshTranslations();
        },

        async onReset() {
            this.form = null;
        },

        async deleteKey(translation) {
            if(confirm(this.$t('translations.delete.confirm'))) {

                let foundTranslations = this.translationsList.filter(t => t.key == translation.key);

                foundTranslations.forEach(async t => {
                    await t.remove();
                });

                await this.refreshTranslations();

            }
        }
    }
}

function readFileAsync(file) {
  return new Promise((resolve, reject) => {
    let reader = new FileReader();

    reader.onload = () => {
      resolve(reader.result);
    };

    reader.onerror = reject;

    reader.readAsText(file);
  })
}
</script>

<style lang="scss">
    .translations-table {
        td {
            padding: 0;
            vertical-align: middle;
            border-top: none;

            input {
                border: none;
                background-color: transparent;
            }
        }
    }
</style>
